export default {
  //Item photo
  Photo: "صورة",
  ChoosePhoto: "اختر صورة",
  RemovePhoto: "إزالة الصورة",
  //Order panel
  CurrentOrder: "الطلب الحالي",
  NoItemsYet: "لا توجد عناصر بعد",
  TapAnItemToAddIt: "اضغط على عنصر لإضافته إلى الطلب",
  //Login
  SetOwnerPin: "تعيين رقم المالك ",
  SetPin: "تعيين دبوس",
  EnterValidName: "ادخل الأسم الصحيح",
  PinMustBeExactly4Characters: "يجب أن يكون رقم التعريف الشخصي بالضبط 4 أحرف",
  PinCodeDoesNotMatch: "الرقم السري غير متطابق",
  //Drawer
  Sales: "مبيعات",
  Receipts: "المبالغ المستلمة",
  Listings: "قوائم",
  Shift: "Shift",
  ShiftReports: "تقارير التحول",
  Settings: "الأعدادات",
  LogoutAttendant: "مضيف الخروج",

  //Sales
  Subtotal: "حاصل الجمع",
  Tax: " ضريبة",
  Discounts: "خصومات",
  TotalPayment: "المبلغ الإجمالي",
  Favorites: "المفضلة",
  All: " الكل",
  Payment: "دفع",
  ItemFavorites: "المفضلة البند",
  WouldYouLikeToIncludeTheItemAsFavorites: "هل ترغب في تضمين العنصر كمفضل ؟",
  WouldYouLikeToRemoveTheItemAsFavorites: "هل ترغب في أزالة العنصر كمفضل ؟",
  EditPrice: "تعديل السعر",
  SetPrice: " تعيين الأسعار",
  EditTransactionLine: "تحرير خط المعاملات",
  Quantity: "كمية",
  SetQuantity: "ضبط الكمية",
  Set: " ادخال",
  SetCommission: "ضبط العمولة",
  Add: " أضف",
  ReceiptLineIsDeleted: "تم حذف خط الأستلام",
  Okay: " حسنا",
  ItIsNotYourShift: "انها ليست التحول الخاص بك",
  //Sales Delete Icon
  ConfirmDelete: "تأكيد الحذف",
  AreYouSureToDeleteReceiptLines: "هل أنت متأكد من حذف خطوط الإيصال؟",
  No: " لا",
  Yes: " نعم",

  //Sales Discount Icon
  Discount: "خصم",
  PleaseAddAnItem: "الرجاء إضافة عنصر",
  OK: " حسنا",
  OnTheFlyDiscount: "خصم سريع",
  ExistingDiscount: "الخصم الحالي",
  DiscountType: "نوع الخصم",
  Percentage: "النسبة المئوية",
  SetDiscount: "تعيين خصم",
  FixDiscount: "تعديل الخصم",
  CurrentDiscountSelected: "الخصم الحالي المحدد",
  NoSelectedDiscount: "لايوجد خصم محدد",
  SelectNewDiscount: "حدد خصم جديد",

  //Sales Search
  SearchItems: "بحث العناصر",

  //Sales View Orders
  ViewOrders: "عرض الطلبات",
  NoOrdersYet: "لاتوجد طلبات حتى الآن",
  ConfirmOrder: "تأكيدالطلب",
  SelectOrderType: "اختر نوع الطلب",
  Cancel: "إلغاء",
  Confirm: "تأكيد",
  AnyPendingTransactionsWillBeOverridedWouldYouLikeToContinue:
    "سيتم تعليق أي معاملات معلقة هل ترغب في الأستمرار ؟. ",
  Orders: "أوامر",
  ORDER: "طلب",
  CancelOrder: "الغاء الطلب",
  TableNo: " الجدول رقم",
  TableNumber: "رقم الجدول",
  ChangeTable: "تغيير الجدول",
  ReprintOrder: "إعادة ترتيب الطلب",

  //Payment
  Pay: " دفع",
  AmountDue: "المبلغ المستحق",
  AmountChange: "تغيير المبلغ",
  Customer: "زبون",
  PaymentType: "نوع الدفع",
  PrinterStatus: "حالة الطباعة",
  NoDefaultPrinter: "لاتوجد طباعة افتراضية",
  AddCustomer: "Add Customer",
  Cash: "Cash",
  Card: "card",
  ConfirmPayment: "تأكيد الدفع",
  AreYouSure: "هل انت متأكد؟",
  Proceed: " تقدم",
  ReceiptInformation: "معلومات الأستلام",
  DoYouWantToPrintReceipt: "هل تريد طباعة إيصال ؟",
  Close: " إغلاق",
  TransactionSummary: "ملخص المعاملات",
  CashPaid: "النقدية المدفوعة",
  Commission: "عمولة",
  Alert: " إنذار",
  AmountPaidMustBeGreaterThanOrEqualToAmuntDue:
    "يجب أن يكون المبلغ المدفوع أكبر من أو يساوي المبلغ المستحق",
  Email: "البريد الألكتروني",
  PhoneNumber: "رقم الجوال",
  Note: "ملحوظة",
  Save: "حفظ",
  NoAddedPrinterDevice: "لايوجد جهاز طابعة مضاف",

  //Receipt
  NoReceiptsAvailable: "لايوجد إيصالات متاحة",
  Receipt: "إيصال",
  Completed: "مكتمل",
  Attendant: "حاضر",
  Offline: "غير متصل ",
  Reprint: "إعادة الطباعة",
  CancelReceipt: "إلغاء الاستلام",
  SoldTo: "بيعت ل :",
  Total: "مجموع",
  NoTax: "لاتوجد ضرائب",
  NoDiscount: "لايوجد خصم",
  AmountPaid: "المبلغ المدفوع",
  Transaction: "عملية تجارية",
  VoidReceipt: "ايصال ملغي",
  AreYouSureYouWantToVoidReceipt: "هل أنت متأكد من إلغاء الإيصال؟",
  Reason: "السبب",
  Cancelled: "ألغيت",

  //Listings
  Items: "العناصر",
  Item: "عنصر",
  Categories: "الاقسام",
  WouldYouLikeToCreateNewItem: "هل ترغب في إنشاء عنصر جديد؟",
  WouldYouLikeToCreateNewCategory: "هل ترغب في إنشاء فئة جديدة؟",
  WouldYouLikeToCreateNewDiscount: "هل ترغب في انشاء خصم جديد؟",
  CreateNewItem: "إنشاء عنصر جديد",
  CreateNewCategory: "إنشاء فئة جديدة",
  CreateNewDiscount: "إنشاء خصم جديد",

  //Listings Items
  Category: "الفئة",
  NoCategory: "لا تصنيف",
  Price: "سعر",
  Barcode: "باركود",
  SoldBy: "تم بيعها من قبل",
  Each: " كل",
  Weight: "وزن",
  OtherInformation: "معلومات أخرى",
  StockKeepingUnit: "وحدة حفظ الأوراق المالية",
  Color: " اللون ",
  Shape: "شكل",
  ShowOptions: "عرض الخيارات",
  PrintBarcode: "طباعة الباركود",
  HideOptions: "إخفاء الخيارات",
  SaveNewItem: "حفظ عنصر جديد",
  SuccessfullyAddedNewItem: "تمت إضافة عنصر جديد بنجاح",

  //Listings categories
  CategoryName: "أسم التصنيف",
  ColorWillApplyToAllItemsUnderThisCategoryForWhichColorIsNotSet:
    "سيتم تطبيق اللون على جميع العناصر الموجودة في هذه الفئة والتي لم يتم تعيين لون لها",
  SaveNewCategory: "حفظ فئة جديدة",
  EnterValidCategoryName: "أدخل أسم الفئة الصالحة",
  EnterValidDiscountName: "أدخل أسم الخصم الصالح",
  EnterAValidItemName: "أدخل اسم العنصر الصالح",
  EnterValidDiscountValue: "أدخل قيمة الخصم الصالح",
  SuccessfullyAddedCategory: "تمت إضافة الفئة بنجاح",
  SuccessfullyAddedDiscount: "تمت إضافة خصم بنجاح",

  //Listings Discounts
  DiscountName: "أسم الخصم",
  DiscountValue: "قيمة الخصم",
  Role: " دور",

  //Shift
  InputValidReason: "أدخال سبب وجيه",
  AddedCash: "النقدية المضافة",
  CashPayoutIsGreaterThanTheCashAvailable: "الدفع النقدي أكبر من النقد المتاح",
  RemovedCash: "إزالة النقدية",
  ShiftDetails: "تفاصيل التحول",
  Amount: "مبلغ",
  Payin: "دفع في",
  Payout: "سيصرف",
  ShiftStarted: "بدأالتحول",
  ShiftStartedOn: "بدأ التحول في ",
  BeginningCash: "بداية النقدية",
  EndingCash: "إنهاء النقدية",
  ShiftOpenedBy: "تحول فتح بواسطة",
  CloseShift: "أغلاق التحول",
  TheCashYouWantedToPutIntoTheRegisterOrGetOutFromTheRegister:
    "المبالغ النفدية التي تريد وضعها في السجل أو الخروج من السجل",
  ActualMoney: "المال الفعلي",
  SetActualMoney: "تعيين المال الفعلي ",
  InvalidAmount: "مبلغ غير صحيح",
  EndedShift: "انتهى التحول",
  WorkedFor: "عملت لحساب",
  AndEndedOn: "انتهت في",
  StartAnotherShift: "بدئ التحول آخر",
  TheCashByTheStartOfTheShift: "النقدية بحلول بداية التحول",
  EnterABeginningCash: "أدخل بدابة النقدية",

  //Shift Reports
  ItemSalesReport: "عناصر تقرير المبيعات",
  CommissionReport: "تقرير العمولة",
  GenerateZReading: "توليد  Z القراءة",
  NoZReadingGenerated: "لا Z القراءة المتولدة",
  ZReadin: "Z قراءة",
  Opened: "افتتح",
  by: "بواسطة",
  TotalNetSales: "إجمالي صافي المبيعات",
  Transactions: "عملية تجارية",
  OpeningAmount: "فتح المبلغ",
  ExpectedDrawer: "الدرج المتوقع",
  Short: "قصير",
  CashSales: "البيع نقدا",
  Payouts: "دفعات",
  Payins: "دفع الإضافية",
  Taxes: "الضرائب",
  Commissions: "عمولات",
  PrintXReport: " Xطباعة تقرير ",
  ShiftInfo: "تحول المعلومات",
  PrintReport: "طباعة تقرير",
  PrintCommissions: "طباعة العمولات",
  Name: " اسم",
  PrintZReport: "طباعة تقرير  Z",

  //Settings
  //Bluetooth
  Bluetooth: "بلوتوث",
  Company: "شركة",
  Sync: "مزامنة",
  Queueing: "الطابور",
  Printer: "طابعة",
  RegisteredDevices: "الأجهزة المسجلة",
  AvailableDevices: "الأجهزة المتاحة",
  BluetoothScanner: "ماسحة بلوتوث",
  Enable: "مكن",
  Connected: "متصل",
  Connecting: "توصيل",
  NotConnected: "غير متصل ",
  AddDevice: "اضف جهاز",
  AreYouSureYouWantToAddThisDevice: "هل أنت متأكدأنك تريد إضافة هذاالجهاز؟ ",
  AreYouSureYouWantToRemoveThisDevice:
    "هل أنت متأكد أنك تريد إزالة هذا الجهاز ؟",
  SuccessfullyAddedDevice: "تمت أضافة الجهاوز بنجاح",
  SuccessfullyRemovedDevice: "تمت إزالة الجهاز بنجاح",
  RemoveDevice: "إنزع الجهاز",

  //Company
  CompanySettings: "إعدادات الشركة",
  Currency: "عملة",
  CompanyHeader: "رأس الشركة",
  CompanyFooter: "شركة تذييل",
  CurrentlyEditingPleaseSaveYourChanges:
    "التحرير حاليا. يرجى حفظ التغيرات الخاصة بك",

  //Attendant
  AddRole: "أضافة دور",
  AttendantName: "أسم الحاضر",
  CanLogin: "يمكن تسجيل الدخول",
  SaveAttendant: "حفظ المصاحبة",
  Pin: " دبوس",
  ConfirmPin: "تأكيد الرقم",
  SuccessfullyAddedAttendant: "تمت أضافة مضيف بنجاح",
  EnterValidPin: "أدخل رمز صالح",
  PleaseConfirmPin: "يرجى تأكيد الرقم",

  //Sync
  Server: "الخادم",
  SyncSettings: "إعادادات المزامنة",
  Username: "أسم المستخدم",
  Password: "كلمة المرور",
  DeviceID: "معرف الجهاز",
  PleaseClickTheEditButton: "الرجاء التقر فوق الزر تحرير (رمز القلم الرصاص)",
  EnterValidAttendantName: "أدخل أسم الشخص الصالح",
  //Queueing
  OtherSettings: "اعدادات اخرى",
  UseDescription: "استخدام الوصف",
  DescriptiveItemNamesInTheListing: "أسماء العناصر الوصفية في القائمة",
  UseDefaultCustomer: "استخدام العميل الفتراضي",
  SetItemStacking: "تعيين عنصر التراص",
  Use: "استعمال",
  EnableThe: "تمكين ",
  Feature: "خاصية",
  HostAddress: "عنوان المضيف",

  //Logout
  ConfirmLogout: "تأكيد تسجيل الخروج",
  AreYouSureYouWantToLogout: "هل أنت متأكد أنك تريد تسجيل الخروج ؟",

  //Select Attendant
  SelectAttendant: "حدد الحضور",
  Next: " التالى",
  None: "لاشيء",
  EnterPin: "أدخل رقم التعريف الشخصي",
  NoAttendant: "لايوجد حاضر",
  PleaseSelectAnyAttendant: "يرجى اختيار أي مضيف",
  PINError: " خطأ PIN ",
  PleaseEnterTheCorrectPINNumber: "الرجاء إدخال رقم التعريف الشخصي الصحيح",
};
